module.exports = __webpack_public_path__ + "static/media/284.5173589d.svg";